<template>
    <b-container fluid>
        <TagHeader :title="title" :buttons="buttons"></TagHeader>
        <SubscriptionContent />
    </b-container>
</template>

<script>
    import TagHeader from "@/components/TagHeader"
    import SubscriptionContent from "@/components/SubscriptionContent"
    import { mapState } from "vuex"

    export default {
        name: "Subscriptions",
        components: {
            TagHeader,
            SubscriptionContent
        },
        data() {
            return {
                title: "Subscriptions",
                breadCrumbTitle: "Connect with ARM > Account Management",
                buttons: [
                    {name:"edit", label:"Personal Profile"},
                    {name:"account", label:"Update Account Details"},
                    {name:"logout", label:"Logout"}
                ]
            }
        },
        // computed: {
        //     ...mapState("auth",["details"]),
        // },
        // created() {
        //     this.$store.dispatch("auth/validateUserSession").then((response) =>{
        //         if (!response.status === 200 || !this.details.username) {
        //             this.$router.push({name: "login"})
        //         }
        //     }).catch(error => {
        //         this.$router.push({name: "login"})
        //     })
        // },
    }
</script>

<style scoped>

</style>